/* import __COLOCATED_TEMPLATE__ from './current-transfer-review.hbs'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import { Account } from '@square/dashboard-protos/models/squareup/banking/account_model';
import { AccountType } from '@square/dashboard-protos/models/squareup/banking/common';
import { EstimatedTransferEvent } from '@square/dashboard-protos/models/squareup/sfs/models/estimated_transfer_event';
let CurrentTransferReview = (_dec = computed('currentTransfer.primaryAccount.name'), _dec2 = computed(), _dec3 = computed('currentTransfer.secondaryAccount'), _dec4 = computed('currentTransfer.secondaryAccount.bankName', 'locationSelector.units'), _dec5 = computed('currentTransfer.secondaryAccount.accountNumberSuffix', 'locationSelector.units'), _dec6 = computed('currentTransfer.isDeposit', 'isInstantTransfer'), _dec7 = computed('transferEvents'), _dec8 = computed('transferEvents'), _dec9 = computed('transferEvents'), _dec10 = computed('currentTransfer.{isDeposit,isFolderToFolderTransfer,remainingWeeklyDeposits}'), _dec11 = computed('currentTransfer.{isDeposit,isFolderToFolderTransfer,remainingWeeklyWithdrawals}'), (_class = class CurrentTransferReview extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "currentTransfer", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "locationSelector", _descriptor3, this);
    _initializerDefineProperty(this, "features", _descriptor4, this);
    _defineProperty(this, "tagName", '');
    _defineProperty(this, "transferEvents", void 0);
  }
  get primaryAccountLabel() {
    return this.currentTransfer.primaryAccount?.name;
  }
  get primaryAccountExtra() {
    return '';
  }
  get isInstantTransfer() {
    if (this.currentTransfer.secondaryAccount instanceof Account) {
      return true;
    } else {
      return false;
    }
  }
  get secondaryAccountLabel() {
    const account = this.currentTransfer.secondaryAccount;
    if (account === null) {
      throw new Error('cannot render null secondary account in transfer review');
    } else if (account instanceof Account) {
      if (account.type === AccountType.SAVINGS_ACCOUNT) {
        return account.name;
      }
      return this.locationSelector.units.find(unit => {
        if (account.owner) {
          return unit.token === account.owner.id;
        } else {
          return false;
        }
      })?.nickname;
    } else {
      return account.bankName;
    }
  }
  get secondaryAccountExtra() {
    const account = this.currentTransfer.secondaryAccount;
    if (account === null) {
      throw new Error('cannot render null secondary account in transfer review');
    } else if (account instanceof Account) {
      return '';
    } else {
      return account.accountNumberSuffix;
    }
  }
  get processingTime() {
    if (this.isInstantTransfer) {
      return this.intl.t('sfs.shared.transfers.confirm.processing.value.instant');
    }
    if (this.currentTransfer.isDeposit) {
      return this.intl.t('sfs.shared.transfers.confirm.processing.value.deposit');
    } else {
      return this.intl.t('sfs.shared.transfers.confirm.processing.value.withdraw');
    }
  }
  get willInitiateAt() {
    return this.transferEvents.find(event => {
      return event.type === EstimatedTransferEvent.Type.INITIATED;
    })?.estimatedTime;
  }
  get willSettleAt() {
    return this.transferEvents.find(event => {
      return event.type === EstimatedTransferEvent.Type.SETTLED;
    })?.estimatedTime;
  }
  get willBeAvailableAt() {
    return this.transferEvents.find(event => {
      return event.type === EstimatedTransferEvent.Type.MADE_AVAILABLE;
    })?.estimatedTime;
  }
  get showDepositRemainingTransfers() {
    return !this.currentTransfer.isFolderToFolderTransfer && this.currentTransfer.isDeposit && this.currentTransfer.remainingWeeklyDeposits != null;
  }
  get showWithdrawalRemainingTransfers() {
    return !this.currentTransfer.isFolderToFolderTransfer && !this.currentTransfer.isDeposit && this.currentTransfer.remainingWeeklyWithdrawals != null;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "currentTransfer", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "locationSelector", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "primaryAccountLabel", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "primaryAccountLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "primaryAccountExtra", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "primaryAccountExtra"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isInstantTransfer", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "isInstantTransfer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secondaryAccountLabel", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "secondaryAccountLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secondaryAccountExtra", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "secondaryAccountExtra"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "processingTime", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "processingTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "willInitiateAt", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "willInitiateAt"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "willSettleAt", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "willSettleAt"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "willBeAvailableAt", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "willBeAvailableAt"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDepositRemainingTransfers", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "showDepositRemainingTransfers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showWithdrawalRemainingTransfers", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "showWithdrawalRemainingTransfers"), _class.prototype)), _class));
export { CurrentTransferReview as default };